import { getUserPursuits } from "@/features/pursuit/api/apiPursuit";
import { useQuery } from "@tanstack/react-query";

export function useGetUserPursuits() {
  return useQuery({
    queryFn: getUserPursuits,
    queryKey: ["user-pursuits"],
  });
}
